import * as _ from 'lodash';
import * as utils from 'common/utils';
import { transformSpectrumCoordinates } from 'common/utils/spectrumTransformations';

/**
 * Converts Y-axis units for all overlay points in spectrum overlay mode
 */
export function convertOverlayPointsYUnit(selectedPoints, newYUnit, prevYUnit, config, getShaftSpeed) {
  const updatedPoints = _.cloneDeep(selectedPoints);

  updatedPoints.forEach((point, index) => {
    // Spectrum points only — waveform overlays have no Y-unit (dB) toggle.
    if (point.spectrum_data) {
      const currentXUnit = point.xUnit || (config && config.spectrum && config.spectrum.freq_units) || 'Hz';
      const originalXUnit = point.originalResponse ? point.originalResponse.freq_units : 'Hz';
      const shaftSpeed = point.shaft_speed || getShaftSpeed();
      const originalYUnit = point.originalResponse ? point.originalResponse.amp_units :
        (point.yUnit || prevYUnit);

      if (point.originalData) {
        const originalData = _.cloneDeep(point.originalData);

        let processedData = originalData;

        if (newYUnit.toLowerCase() === 'db' && originalYUnit.toLowerCase() !== 'db') {
          const reference = utils.getAmplitudeConversionReference(originalYUnit, 'db');
          if (reference) {
            processedData = processedData.map(d => ({
              x: d.x,
              y: utils.convertToDbScale(d.y, reference)
            }));
          }
        } else if (newYUnit.toLowerCase() !== 'db' && originalYUnit.toLowerCase() === 'db') {
          const reference = utils.getAmplitudeConversionReference('db', newYUnit);
          if (reference) {
            processedData = processedData.map(d => ({
              x: d.x,
              y: utils.convertFromDbScale(d.y, reference)
            }));
          }
        }

        if (currentXUnit !== 'Hz' && shaftSpeed && shaftSpeed > 0) {
          const transformationResult = transformSpectrumCoordinates({
            sourceUnit: originalXUnit,
            targetUnit: currentXUnit,
            shaftSpeed,
            spectrumData: processedData,
            originalData: null,
            features: point.originalFeatures,
            originalFeatures: point.originalFeatures
          });

          updatedPoints[index].spectrum_data = transformationResult.spectrumData;
          updatedPoints[index].spectrumFeatures = transformationResult.features;
        } else {
          updatedPoints[index].spectrum_data = processedData;
          if (point.originalFeatures) {
            updatedPoints[index].spectrumFeatures = _.cloneDeep(point.originalFeatures);
          }
        }
      } else {
        const reference = utils.getAmplitudeConversionReference(
          point.yUnit || prevYUnit,
          newYUnit
        );

        if (reference) {
          if (newYUnit.toLowerCase() === 'db' &&
            (!point.yUnit || point.yUnit.toLowerCase() !== 'db')) {
            updatedPoints[index].spectrum_data = point.spectrum_data.map(d => ({
              x: d.x,
              y: utils.convertToDbScale(d.y, reference)
            }));
          } else if (newYUnit.toLowerCase() !== 'db' &&
            point.yUnit && point.yUnit.toLowerCase() === 'db') {
            updatedPoints[index].spectrum_data = point.spectrum_data.map(d => ({
              x: d.x,
              y: utils.convertFromDbScale(d.y, reference)
            }));
          }
        }
      }

      updatedPoints[index].yUnit = newYUnit;
    }
  });

  return updatedPoints;
}
